<mat-toolbar-row class="bg-gray-50" fxLayoutAlign="space-between center">
    <h2 matDialogTitle tabindex="0" class="text-lg font-medium text-gray-700 text-truncate">{{ title | translate }} {{ additionalText | translate }}</h2>
    <span class="example-spacer"></span>
    <button
        mat-icon-button
        attr.aria-label="{{ 'GENERAL.BUTTON.CLOSE' | translate }} {{ 'GENERAL.LABEL.ARIA_ACTION' | translate }}"
        tabindex="0"
        (click)="onClickButton($event)"
        (keydown.enter)="onClickButton($event)"
    >
        <mat-icon class="close-dialog pointer">{{ closeIcon }}</mat-icon>
    </button>
</mat-toolbar-row>
